import classNames from "classnames";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { Icon } from "../../../components";
import { Spacer } from "../../spacer";
import styles from "./portal_location_select.module.css";

interface PortalBookingCitySelection {
  name: string;
  locations: { name: string; id: string }[];
}

interface PortalLocationSelectProps {
  cities: PortalBookingCitySelection[];
  value: { city?: string; locationId?: string };
  onChange: ({
    city,
    locationId,
  }: {
    city?: string;
    locationId?: string;
  }) => void;
}

export function PortalLocationSelect({
  cities,
  value,
  onChange,
}: PortalLocationSelectProps) {
  const locationList = cities.find((c) => c.name === value.city)?.locations;

  const handleSelectCity = (city: string | null) => {
    if (value.city !== city) {
      onChange({ city: city ?? undefined, locationId: undefined });
    }
  };

  return (
    <div className={styles.component}>
      <div className={styles.locationSelectionWrapper}>
        <Dropdown
          className={classNames("checkout-box-picker", styles.eachSelection)}
          onSelect={handleSelectCity}
        >
          <Dropdown.Toggle>
            <div className={styles.selectionToggle}>
              <div className={styles.selectionToggleContent}>
                <div className={styles.title}>City</div>
                <Spacer size={8} />
                <div>{value.city ?? "Select"}</div>
              </div>
              <Icon name="fi-chevron-down" size={16} />
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {cities.map((c) => (
              <Dropdown.Item key={c.name} eventKey={c.name}>
                {c.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown
          className={classNames("checkout-box-picker", styles.eachSelection)}
          onSelect={(v) =>
            onChange({ locationId: v ?? undefined, city: value.city })
          }
        >
          <Dropdown.Toggle disabled={!value.city}>
            <div className={styles.selectionToggle}>
              <div className={styles.selectionToggleContent}>
                <div className={styles.title}>Location</div>
                <Spacer size={8} />
                <div>
                  {locationList?.find((l) => l.id === value.locationId)?.name ??
                    "Select"}
                </div>
              </div>
              <Icon name="fi-chevron-down" size={16} />
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {locationList?.map((l) => (
              <Dropdown.Item key={l.id} eventKey={l.id}>
                {l.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}
